<template>
  <div v-if="activeVenue">
    <vs-row vs-justify="center">
      <vx-card no-shadow class="max-w-xl">
        <vs-breadcrumb class="mt-2">
          <li
            class="cursor-pointer"
            aria-current="page"
            v-for="(item, idx) in scope"
            :key="item.id"
            :class="{ active: idx == scope.length - 1 }"
            @click="changeScopeTo(item, idx)"
          >
            {{ item.name }}
            <span class="vs-breadcrum--separator">/</span>
          </li>
        </vs-breadcrumb>
        <vs-divider />
        <vs-progress v-if="isFetchingFiles" indeterminate color="primary"></vs-progress>
        <vs-table
          v-else
          v-model="selected"
          @selected="item => (item.isFolder ? enterFolder(item) : viewFile(item))"
          :data="sortedScopeFiles"
        >
          <template slot="thead">
            <vs-th> Name </vs-th>
            <vs-th> Created at </vs-th>
            <vs-th> Last modified </vs-th>
            <vs-th> Action </vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :key="idx" :data="tr" v-for="(tr, idx) in data">
              <vs-td :data="data[idx].name">
                <vs-row>
                  <img class="mr-3" style="height:20px;width:auto;" :src="data[idx].iconLink" />
                  {{ data[idx].name }}
                </vs-row>
              </vs-td>

              <vs-td :data="data[idx].createdTime">
                {{ moment(data[idx].createdTime).format("DD-MM-YYYY") }}
              </vs-td>

              <vs-td :data="data[idx].modifiedTime">
                {{ moment(data[idx].modifiedTime).format("DD-MM-YYYY") }}
              </vs-td>

              <vs-td>
                <feather-icon
                  v-if="!data[idx].isFolder && data[idx].hasWebContentLink"
                  @click.stop="downloadFile(data[idx])"
                  icon="DownloadIcon"
                  class="rounded-full hover:bg-grey p-1 transition ease-in-out duration-100"
                  svgClasses="h-4 w-4"
                ></feather-icon>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {},
  data() {
    return {
      moment,
      scope: [],
      selected: [],
    };
  },
  async mounted() {
    await this.$store.dispatch("venues/ensureUserVenues");
    this.scope.push({
      id: "",
      name: this.activeVenue.name,
    });
    await this.$store.dispatch("venueDrive/listDirectory", {
      folderId: "",
      venueId: this.activeVenue.venueId,
    });
  },
  methods: {
    async enterFolder(folder) {
      if (this.isFetchingFiles) return;
      this.scope.push(folder);
      await this.$store.dispatch("venueDrive/listDirectory", {
        folderId: folder.id,
        venueId: this.activeVenue.venueId,
      });
    },
    async changeScopeTo(folder, idx) {
      if (this.isFetchingFiles) return;
      this.scope.splice(idx + 1);
      await this.$store.dispatch("venueDrive/listDirectory", {
        folderId: folder.id,
        venueId: this.activeVenue.venueId,
      });
    },
    async viewFile(file) {
      if (this.isFetchingFiles) return;
      await this.$store.dispatch("venueDrive/setDomainPermission", file.id);
      window.open(file.webViewLink, "_blank").focus();
    },
    async downloadFile(file) {
      if (this.isFetchingFiles) return;
      console.log("Download", file);
      await this.$store.dispatch("venueDrive/setDomainPermission", file.id);
      window.open(file.webContentLink, "_blank").focus();
    },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      currentScopeFiles: "venueDrive/currentScopeFiles",
      isFetchingFiles: "venueDrive/loading",
    }),
    sortedScopeFiles() {
      const list = this.currentScopeFiles;
      list.sort((a, b) => (a.isFolder && !b.isFolder ? -1 : 1));
      return list;
    },
  },
};
</script>

<style lang="scss">
.googledrive-filepicker {
  .vs-list--item:hover {
    background: rgba(0, 0, 0, 0.05);
  }
}
</style>
